<div id='login-page' class="primary-background">
  <div id="login-form">
        <nb-card *ngIf=!setPassword>
          <nb-card-header>{{'password_confirm_attributes'| translation}}</nb-card-header>
          <nb-card-body class="input-card-body">
            <div *ngFor="let attribute of objectKeys(currentAttributes)">
              <div *ngIf="attribute =='phone_number'">
                <div class="phone-number" *ngIf="currentAttributes['phone_number'] && !newPhone">
                  {{'phone_number'| translation}} : {{currentAttributes['phone_number']}}  <button nbButton status="primary" (click)="newPhone = true">Change</button>
                </div>
                <div *ngIf='currentAttributes["phone_number"] == "" || newPhone'>
                  <app-phone-number (changed)="phoneNumberChanged($event)" [item]></app-phone-number>
                </div>
              </div>
              <nb-form-field *ngIf="attribute =='email' || attribute =='family_name'|| attribute =='given_name'">
                <label [for]="attribute">{{attibutesName(attribute)}}</label>
                <input [(ngModel)]="currentAttributes[attribute]" [name]="attribute" nbInput [placeholder]="attibutesName(attribute)" [required]=isAttributeRequired(attribute) (change)="attributeChanged(attribute)">
              </nb-form-field>
            </div>
            <div class="button-holder">
              <button nbButton (click)=location.back() status="basic">{{'cancel'| translation}}</button>

              <button nbButton (click)="setPassword = true" status="primary" [disabled]="stillRequiredAttributes()">{{'continue'| translation}}</button>
            </div>
          </nb-card-body>
        </nb-card>

        <nb-card *ngIf="setPassword">
          <ng-container *ngIf="!policies;else loaded">
            <div  class="new-password-loading-spinner">
              <span><i class="fas fa-spinner fa-spin"></i></span>
            </div> 
          </ng-container>
          <ng-template #loaded>
          <nb-card-header>{{'password_new_set'| translation}}</nb-card-header>
          <nb-card-body class="input-card-body">
            <p>{{'password_new_set'| translation}}:</p>
            <p *ngIf="policies?.MinimumLength > 0" [ngClass]="{'strike-through' : newPassword.dirty && (!newPassword.errors || !newPassword.errors.minlength)}">{{'requirement_minimum_length'| translation}}: {{policies?.MinimumLength}}</p>
            <p *ngIf="policies?.RequireUppercase" [ngClass]="{'strike-through' : newPassword.dirty && (!newPassword.errors || !newPassword.errors.mustHaveUpercase)}">{{'requirement_uppercase'| translation}}</p>
            <p *ngIf="policies?.RequireLowercase" [ngClass]="{'strike-through' : newPassword.dirty && (!newPassword.errors || !newPassword.errors.mustHaveLowercase)}">{{'requirement_lowercase'| translation}}</p>
            <p *ngIf="policies?.RequireNumbers" [ngClass]="{'strike-through' : newPassword.dirty && (!newPassword.errors || !newPassword.errors.mustHaveNumber)}">{{'requirement_number'| translation}}</p>
            <p *ngIf="policies?.RequireSymbols" [ngClass]="{'strike-through' : newPassword.dirty && (!newPassword.errors || !newPassword.errors.mustHaveSpecialCharacter)}">{{'requirement_special_character'| translation}}</p>
            <div>
              <nb-form-field class="form-field">
                <label>{{'password_old'| translation}}</label>
                <input #oldPassword="ngModel" [(ngModel)]="oldPw" nbInput [placeholder]="'password_old'| translation" type="password" required>
              </nb-form-field>
            </div>
            <div>
              <nb-form-field>
                <label for="newPw">{{'password_new'| translation}}</label>
                <input #newPassword="ngModel" [(ngModel)]="newPw" nbInput [placeholder]="'password_new'| translation" type="password"
                       required
                       [minlength]="policies.MinimumLength"
                       [mustHaveUpercase]="policies.RequireUppercase"
                       [mustHaveLowercase]="policies.RequireLowercase"
                       [mustHaveNumber]="policies.RequireNumbers"
                       mustContainCharacters="{{ policies.RequireSymbols ? COGNITO_SPECAIL_CHARACTER_REGEX : null}}">
              </nb-form-field>
            </div>
            <div>
              <nb-form-field>
                <label for="confirmPw">{{'password_confirm'| translation}}</label>
                <input #confirmPassword="ngModel" [(ngModel)]="confirmPw" name="confirmPw" nbInput [placeholder]="'password_confirm'| translation" type="password" required mustMatchInput="{{newPw}}">
              </nb-form-field>
            </div>

            <password-strength-meter (strengthChange)="passwordStrength=$event" style="display: block;" [minPasswordLength]="policies?.MinimumLength||7" [enableFeedback]="true" [password]="newPw"></password-strength-meter>

            <div class="button-holder">
              <button nbButton (click)="newPw = ''; confirmPw = ''; setPassword = false;">{{'back'| translation}}</button>
              <button nbButton (click)="submitNewPw()" status="primary" [disabled]="newPassword.invalid || confirmPassword.invalid">{{'submit'| translation}}</button>
            </div>
          </nb-card-body>
        </ng-template>
        </nb-card>
  </div>
</div>
